// @givmo/fundraisers-module — every line the console's bonus pledges add (FCM-WEB35; its mockups RULED as
// D-FCM-77, 2026-11-03, revision 7's copy list). A bonus pledge is Jonathan's 2026-10-27 name (D-FCM-70,
// D-GFU-66) for a pledge of one amount that pays only if something happens in a game. Marks:
//   RULED   a ruling's own words (named);
//   REUSED  a shipped line, word for word (its file and line);
//   SERVED  the server's own sentence, shown as served;
//   NEW     in no ruled file before this set.
// Buttons name their act in a word or three (D-FCM-71's rule); every figure is whole dollars (§4a).

export const BONUS_COPY = {
  // ── The game's tab ────────────────────────────────────────────────────────────────────────────────
  /** NEW (the name RULED, D-GFU-66): the tab on a game's page, and its card's title. */
  tab: 'Bonus pledges',
  /** NEW: the card's one line. */
  description: 'Fans pledge one amount that’s charged only if it happens.',
  /** NEW (three words, D-FCM-71): the tab's act and the form's. */
  add: 'Add bonus pledge',
  /** NEW, the pattern of "No layers yet" (`layers-copy.ts:55`). */
  emptyTitle: 'No bonus pledges yet',
  /** NEW. */
  emptyBody: 'Add one when something worth cheering for could happen in the game.',
  /** NEW, the pattern of the Layers tab's `editorLine` (`layers-copy.ts:52`): someone below the owner rank. */
  viewOnly: 'You can view this game’s bonus pledges. Its owners can add, stop or settle them.',
  /** NEW: while the game hides its figures from fans (D-FCM-26), its public read nulls the pledges' figures,
   *  which the tab reads; what came in still shows (the organizer's own totals, FCM-BE63). */
  figuresHidden:
    'While this game hides its figures from fans, its pledges’ figures don’t show here.',

  // ── The form ──────────────────────────────────────────────────────────────────────────────────────
  /** NEW (a title keeps its words, as "Set up a season" did under D-FCM-71). */
  dialogTitle: 'Add a bonus pledge',
  /** NEW. */
  whatUnlocks: 'What unlocks it?',
  /** NEW. */
  kindMoment: 'Something happens',
  /** NEW: who decides, the one line under the choice. */
  kindMomentLine: 'You say whether it happened.',
  /** NEW: the count the game's scoreboard keeps, by its unit's plural ("Runs reach a number"). */
  kindCount: (units: string) => `${units.charAt(0).toUpperCase()}${units.slice(1)} reach a number`,
  /** NEW. */
  kindCountLine: 'It unlocks on its own from the score.',
  /** NEW. */
  momentLabel: 'What has to happen?',
  /** NEW: the deck's example, as the field's one line (never a placeholder that reads as typed). */
  momentExample: 'For example, “Soto gets the game-winning hit”.',
  /** NEW: the count's number ("At least" before it, the unit after it). */
  atLeast: 'At least',
  /** NEW: the count now, from the game's scoreboard ("The Herons have 3 now."). */
  countNow: (subject: string, count: string) => `The ${subject} have ${count} now.`,
  /** NEW. */
  amount: 'Amount',
  /** NEW: after the amount ("$5 a fan", the game page's `perFan`). */
  aFan: 'a fan',
  /** NEW (the field's label; a charity's console shows its own name under it, with no choice: Q8). */
  charity: 'Charity',
  /** NEW: under a company's choice while it is the game's own. */
  gamesCharity: 'The game’s charity',
  /** NEW: a company season whose pages may pick any charity (no list binds them): the search's placeholder
   *  and name. */
  charitySearch: 'Search charities',
  /** NEW: over the search, under the game's own charity, which stays first. */
  orAnotherCharity: 'Or another charity',
  /** NEW: a search that finds none. */
  noCharityFound: 'No charity by that name.',
  /** NEW: over the preview of the fans' card, by the act: when pledging opens (D-GFU-57: at publish) and
   *  when it ends (the proposed act closes it with the game; an "at least N" count at N, D-GFU-65). The
   *  market's live tools say how long an item runs (Twitch's poll duration); this says it in words. */
  fansPledgeUntilEnd: 'Fans can pledge as soon as you add it, until the game ends.',
  fansPledgeUntilCount: (subject: string, count: number) =>
    `Fans can pledge as soon as you add it, until the ${subject} reach ${count} or the game ends.`,
  /** RULED (D-FCM-70, 2026-10-27 12:40): the card's charity line, only where it pays another charity. */
  forCharity: (name: string) => `For ${name}`,
  /** RULED (D-GFU-47): the card's button. */
  pledgeAmount: (amount: string) => `Pledge ${amount}`,
  /** REUSED (`layer-dialogs.tsx:378`). */
  cancel: 'Cancel',
  /** NEW, the module's toast pattern ("Layer added.", `layers-copy.ts:117`). */
  added: 'Bonus pledge added.',
  /** NEW: the module's own line when the act gets no answer (the module's `layerFailed` pattern). */
  failed: 'Couldn’t add the bonus pledge. Please try again.',
  /** NEW: the same for the row's two acts, which the set draws no failure for (the same pattern). */
  stopFailed: 'Couldn’t stop pledging. Please try again.',
  lockFailed: 'Couldn’t lock the result. Please try again.',
  /** NEW: what to do after each refusal (each beside the server's own sentence). */
  reachedNext: (subject: string, count: string) =>
    `The ${subject} have ${count} now. Choose a higher number.`,
  bettingNext: 'Say it another way.',
  charityNext: 'Choose another charity.',

  // ── Each bonus pledge on the tab ───────────────────────────────────────────────────────────────────
  /** NEW: the state words, said plainly (Ramp's "Active": a word, no pill). */
  open: 'Open',
  /** RULED (D-FCM-70, 12:48 and 13:54): the fans' word, without its "Bonus pledge". */
  pending: 'Pending',
  /** RULED (D-FCM-70, 13:54): the fans' "Bonus unlocked!", said as a state. */
  unlocked: 'Unlocked',
  /** NEW. */
  didntHappen: 'Didn’t happen',
  /** NEW (GFU's rule 5: no result in time). */
  noResult: 'Ended without a result',
  /** REUSED (the game page's `perFan`, `apps/donate/app/lib/game-page-copy.ts:53`). */
  perFan: (amount: string) => `${amount} a fan`,
  /** NEW: an open one nobody has pledged on yet, in place of "0 pledges · $0 pledged". */
  noPledgesYet: 'No pledges yet',
  /** NEW (a counted noun reads singular at one, the module's rule). */
  pledges: (n: number) => (n === 1 ? '1 pledge' : `${n.toLocaleString('en-US')} pledges`),
  /** REUSED (the game page's `amountPledged`, `game-page-copy.ts:57`): decision 7, the organizer's word
   *  until the charges run. */
  pledged: (amount: string) => `${amount} pledged`,
  /** NEW: an unlocked bonus pledge's gifts through "Donate $5" (SERVED: the game page's button,
   *  `game-page-copy.ts:51`, D-GRP-77 of 2026-11-02 superseding D-GFU-65's "Give $5"), on a line of their own
   *  under its pledges, so no one reads them as pledges (the card's line is about pledges). */
  giftsSince: (raised: string, n: number, amount: string) =>
    `Since it unlocked: ${raised} from ${n === 1 ? `1 “Donate ${amount}” gift` : `${n.toLocaleString('en-US')} “Donate ${amount}” gifts`}`,
  /** NEW. */
  nothingCharged: 'Nothing is charged',
  /** NEW (decision 5): the bonus pledge's own close, a word apart from the header's "Close game page". */
  stopPledging: 'Stop pledging',
  /** NEW (the mission's words, as buttons). */
  itHappened: 'It happened',
  itDidnt: 'It didn’t',

  // ── Stop pledging ─────────────────────────────────────────────────────────────────────────────────
  /** NEW. */
  stopTitle: 'Stop pledging now?',
  /** NEW: its first sentence the apps' (`PledgeCopy.swift:1128`), saying plainly what can't be undone: a
   *  closed pledge can't reopen (GFU-BE20's close has no way back). */
  stopBody:
    'No one can pledge after this, and pledging can’t be reopened. Pledges already made still count if it happens.',
  /** NEW. */
  stopped: 'Pledging stopped.',

  // ── Its result (a moment the staff settle) ────────────────────────────────────────────────────────
  /** NEW. */
  lockHappenedTitle: 'Lock “It happened”?',
  lockDidntTitle: 'Lock “It didn’t”?',
  /** NEW: before a body, while it still takes pledges (the lock stops them first). */
  stopsNow: 'Pledging stops now.',
  /** NEW: the apps' 48-hour rule in plain words ("Nothing is charged until 48 hours after pledgors are
   *  told the result.", `PledgeCopy.swift:1140`): Givmo's own notice tells them
   *  (`pledge_notice_service.py`: "we'll email and notify you 48 hours before any" charge). */
  // The time to cancel first, then the pledged total, so the figure never reads as settled before it is: a pledgor
  // may cancel until their charge, 48 hours after Givmo’s notice (`POST /users/me/pledges/{id}/cancel`, open
  // until the deadline in its notice).
  lockHappenedBody: (pledges: number, total: string, charity: string) =>
    `Givmo emails the result to ${pledges === 1 ? 'the 1 person' : `the ${pledges.toLocaleString('en-US')} people`} who pledged. They have 48 hours to cancel. Then their ${total} goes to ${charity}. Once locked, the result can’t be changed.`,
  /** NEW (no frame draws it): the same while the game hides its figures, whose read then names neither the
   *  people nor the total (D-FCM-26), so the line names neither. */
  lockHappenedBodyHidden: (charity: string) =>
    `Givmo emails the result to the people who pledged. They have 48 hours to cancel. Then their pledges go to ${charity}. Once locked, the result can’t be changed.`,
  /** COMPOSED of the Copy's own lines ("No pledges yet", then the lock's last sentence): the same while nobody
   *  has pledged on it, where the 48-hour line would name "the 0 people" and "$0" (review-105's F7). */
  lockHappenedBodyNone: 'No pledges yet. Once locked, the result can’t be changed.',
  /** NEW (D-FCM-70: a bonus pledge that didn't happen comes off the fans' game page; decision 8: its own
   *  page closes, FCM-BE180). */
  lockDidntBody:
    'No one is charged. It comes off the game page fans see, and its page in the Layers tab closes. Once locked, the result can’t be changed.',
  /** REUSED (iOS `PledgeCopy.lockResult`, `PledgeCopy.swift:1200`). */
  lockResult: 'Lock result',
  /** NEW: each answer's own toast, so the one locked is never in doubt. */
  lockedHappened: 'Locked: it happened.',
  lockedDidnt: 'Locked: it didn’t happen.',
} as const;

/** The server's sentences these screens show before or beside a refusal, verbatim (straight apostrophes,
 *  as the backend writes them). Each is SERVED: the screens never compose one. */
export const BONUS_SERVER_WORDS = {
  /** `REACHED_ALREADY_DETAIL`, `app/application/pledge_service.py:1299` (409 `PLEDGE_COUNT_REACHED`,
   *  `PledgeCountReachedException`). */
  reachedAlready: 'This count has already reached that number',
  /** FCM-BE180's `BONUS_PLEDGE_CHARITY_UNAVAILABLE_DETAIL` (`app/domain/campaign_bonus_pledges.py`; D-FCM-77,
   *  FCM-BE141's pattern), with its curly apostrophe as the backend writes it. */
  charityUnavailable: 'The charity this bonus pledge would raise for isn’t available.',
} as const;
